module.exports = __webpack_public_path__ + "static/media/21a.202bbb49.jpg";